import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import { NeutralGender } from './svg/neutralGender';

export const NeutralGenderIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={NeutralGender} {...props} />
);
